import { useEffect, useState } from "react";

import Image1Community from "../images/community/1.webp";
import Image2Community from "../images/community/2.webp";
import Image3Community from "../images/community/3.webp";
import Image4Community from "../images/community/4.webp";
import Image5Community from "../images/community/5.webp";
import Image6Community from "../images/community/6.webp";
import Image7Community from "../images/community/7.webp";
import Image8Community from "../images/community/8.webp";
import Image9Community from "../images/community/9.webp";
import Image10Community from "../images/community/10.webp";
import Image11Community from "../images/community/11.webp";
import Image12Community from "../images/community/12.webp";

// Zdjęcia dajemy 1000x1000 px

import "../css/community.css";

import useDictionary from '../hooks/useDictionary';

const COMMUNITY_ITEMS = [
    {
        id: 12,
        type: "image",
        src: Image12Community,
        alt: "Pamiątka od klienta Negativ",
        title: "List od Asi K.",
    },
    {
        id: 1,
        type: "image",
        src: Image1Community,
        alt: "Pamiątka od klienta Negativ",
        title: "List od klienta",
    },
    {
        id: 2,
        type: "image",
        src: Image2Community,
        alt: "Pamiątka od klienta Negativ",
        title: "Podziękowanie",
    },
    {
        id: 3,
        type: "image",
        src: Image3Community,
        alt: "Pamiątka od klienta Negativ",
        title: "Upominek",
    },
    {
        id: 4,
        type: "image",
        src: Image4Community,
        alt: "Pamiątka od klienta Negativ",
        title: "Wspomnienie współpracy",
    },
    {
        id: 5,
        type: "image",
        src: Image5Community,
        alt: "Pamiątka od klienta Negativ",
        title: "Dobre słowo",
    },
    {
        id: 6,
        type: "image",
        src: Image6Community,
        alt: "Pamiątka od klienta Negativ",
        title: "Liścik",
    },
    {
        id: 7,
        type: "image",
        src: Image7Community,
        alt: "Pamiątka od klienta Negativ",
        title: "Liścik",
    },
    {
        id: 8,
        type: "image",
        src: Image8Community,
        alt: "Pamiątka od klienta Negativ",
        title: "Liścik",
    },
    {
        id: 9,
        type: "image",
        src: Image9Community,
        alt: "Pamiątka od klienta Negativ",
        title: "Liścik",
    },
    {
        id: 10,
        type: "image",
        src: Image10Community,
        alt: "Pamiątka od klienta Negativ",
        title: "Liścik",
    },
    {
        id: 11,
        type: "image",
        src: Image11Community,
        alt: "Pamiątka od klienta Negativ",
        title: "Książka z dedykacją",
    },
];

function CommunityTile({ item, index, onOpen }) {

    const dictionary = useDictionary();

    return (
        <button
            className={`community-tile community-tile--${item.type}`}
            type="button"
            onClick={() => onOpen(index)}
            style={{ animationDelay: `${index * 55}ms` }}
            aria-label={`Otwórz pamiątkę: ${item.title}`}
        >
            <span className="community-tile__media">
                {item.type === "video" ? (
                    <video src={item.src} muted playsInline preload="metadata" />
                ) : (
                    <img src={item.src} alt={item.alt} loading="lazy" />
                )}
            </span>

            <span className="community-tile__overlay">
                <span className="community-tile__label">{item.type === "video" ? dictionary.MOVIE : dictionary.PHOTO }</span>
                <span className="community-tile__title">{item.title}</span>
            </span>
        </button>
    );
}

export default function Community() {

    const dictionary = useDictionary();

    const [activeIndex, setActiveIndex] = useState(null);
    const activeItem = activeIndex !== null ? COMMUNITY_ITEMS[activeIndex] : null;

    const closePreview = () => setActiveIndex(null);
    const showPrevious = () => {
        setActiveIndex((currentIndex) => (
            currentIndex === 0 ? COMMUNITY_ITEMS.length - 1 : currentIndex - 1
        ));
    };
    const showNext = () => {
        setActiveIndex((currentIndex) => (
            currentIndex === COMMUNITY_ITEMS.length - 1 ? 0 : currentIndex + 1
        ));
    };

    useEffect(() => {
        if (activeIndex === null) {
            return undefined;
        }

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                closePreview();
            }

            if (event.key === "ArrowLeft") {
                showPrevious();
            }

            if (event.key === "ArrowRight") {
                showNext();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        document.body.classList.add("community-preview-open");

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.body.classList.remove("community-preview-open");
        };
    }, [activeIndex]);

    return (
        <section className="community" aria-label="Galeria pamiątek od klientów">
            <div className="community__intro">
                <p>
                    {dictionary.GIFTS_FROM_CLIENTS}
                </p>
            </div>

            <div className="community__grid">
                {COMMUNITY_ITEMS.map((item, index) => (
                    <CommunityTile
                        key={item.id}
                        item={item}
                        index={index}
                        onOpen={setActiveIndex}
                    />
                ))}
            </div>

            {activeItem && (
                <div className="community-lightbox" role="dialog" aria-modal="true" aria-label={activeItem.title}>
                    <button
                        className="community-lightbox__backdrop"
                        type="button"
                        onClick={closePreview}
                        aria-label="Zamknij podgląd"
                    />

                    <div className="community-lightbox__content">
                        <button
                            className="community-lightbox__close"
                            type="button"
                            onClick={closePreview}
                            aria-label="Zamknij"
                        >
                            <span />
                            <span />
                        </button>

                        <button
                            className="community-lightbox__nav community-lightbox__nav--prev"
                            type="button"
                            onClick={showPrevious}
                            aria-label="Poprzednia pamiątka"
                        >
                            &lsaquo;
                        </button>

                        <div className="community-lightbox__media">
                            {activeItem.type === "video" ? (
                                <video src={activeItem.src} controls autoPlay playsInline />
                            ) : (
                                <img src={activeItem.src} alt={activeItem.alt} />
                            )}
                        </div>

                        <button
                            className="community-lightbox__nav community-lightbox__nav--next"
                            type="button"
                            onClick={showNext}
                            aria-label="Następna pamiątka"
                        >
                            &rsaquo;
                        </button>

                        <div className="community-lightbox__caption">
                            <span>{activeItem.type === "video" ? dictionary.MOVIE : dictionary.PHOTO }</span>
                            <strong>{activeItem.title}</strong>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
